/**
 * 点对象转地图点实例
 */
function pathPointsToMapPoints(pathPoints) {
    return pathPoints.map(({ lng, lat }) => new BMapGL.Point(lng, lat));
}
function getPoint({ lng, lat }) {
    return new BMapGL.Point(lng, lat);
}

export { getPoint, pathPointsToMapPoints };
